import React from "react";
import { Grid2 as Grid, TextField, useMediaQuery, useTheme, ToggleButton, ToggleButtonGroup } from "@mui/material";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import { useStyles } from "../../Search.styles";

type SearchInputProps = {
	searchText: string;
	isSearchTypeText: boolean;
	onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onSearch: () => void;
	onChangeSearchType: (e: React.MouseEvent<HTMLElement>, value: boolean) => void;
};
export const SearchInput = ({
	searchText,
	isSearchTypeText,
	onTextChange,
	onSearch,
	onChangeSearchType,
}: SearchInputProps) => {
	const classes = useStyles();
	const theme = useTheme();
	const isMediumOrLarger = useMediaQuery(theme.breakpoints.up("md"));
	const searchButtonRef = React.useRef<HTMLButtonElement>(null);
	const searchTextBarRef = React.useRef<HTMLInputElement>(null);

	return (
		<>
			<Grid size={{ xs: 7, sm: 9, md: 11 }}>
				<TextField
					id="searchText"
					type={isMediumOrLarger || isSearchTypeText ? "text" : "number"}
					variant="outlined"
					onChange={onTextChange}
					fullWidth
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							onSearch();
							searchButtonRef.current && searchButtonRef.current.focus();
						}
					}}
					autoFocus
					inputRef={searchTextBarRef}
					value={searchText}
				/>
			</Grid>
			{!isMediumOrLarger && (
				<Grid size={{ xs: 2, sm: 1 }}>
					<ToggleButtonGroup
						orientation="horizontal"
						value={isSearchTypeText}
						exclusive
						className={classes.searchButton}
						onChange={onChangeSearchType}
					>
						<ToggleButton value={true} aria-label="text">
							<KeyboardIcon />
						</ToggleButton>
					</ToggleButtonGroup>
				</Grid>
			)}
		</>
	);
};
